// app/src/lib/snapping/types.ts
export type Vec3 = [number, number, number];

export type SnapKind = 'vertex' | 'midpoint' | 'edge' | 'surface' | 'none';

/** A resolved snap for the current pointer position. */
export interface SnapResult {
  kind: SnapKind;
  /** World position (project SRID, Z-up) to place the vertex at. */
  position: Vec3;
  /** Feature the snap came from, when kind is vertex/midpoint/edge. */
  sourceFeatureId?: string;
}

export interface VertexCandidate {
  kind: 'vertex';
  position: Vec3;
  featureId: string;
}
export interface MidpointCandidate {
  kind: 'midpoint';
  position: Vec3;
  featureId: string;
}
export interface EdgeCandidate {
  kind: 'edge';
  a: Vec3;
  b: Vec3;
  featureId: string;
}
export type SnapCandidate = VertexCandidate | MidpointCandidate | EdgeCandidate;

/** Which geometry snap kinds are active. */
export interface SnapSettings {
  enabled: boolean;
  targets: { vertex: boolean; midpoint: boolean; edge: boolean };
}

export const DEFAULT_SNAP_SETTINGS: SnapSettings = {
  enabled: true,
  targets: { vertex: true, midpoint: true, edge: true },
};

/** Default screen-space snap radius in pixels (matches AddPolygonTool's 14px). */
export const SNAP_THRESHOLD_PX = 12;
